<template>
  <section>
    <h2 class="hide">IR브리프</h2>
    <div class="filer_area" v-show="tabKbn != 'All'">
     <!--  <button type="button" class="btn_filter">필터 <span>2</span></button> -->
     <div class="droplayer icon setting large right nosel">
          <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">설정</v-btn>
              </template>
              <div class="dropdown-list">
                  <div class="dropdown-list-item" v-if="shareInfoManageYn" >
                      <div class="tit">
                          <router-link :to="{ name: 'shareInfoManage' }"  > 
                              <button type="button">{{ $i18nUtil.trans("title.ShareInfoManageHeader.001","정보공유 카테고리 관리") }}</button>
                          </router-link>
                          
                      </div>
                  </div>
                  <div class="dropdown-list-item">
                      <div class="tit">
                          <router-link :to="{ name: 'shareInfoBoardManage' }">
                              <button type="button">{{ $i18nUtil.trans("button.post.manage","게시물 관리") }}</button>
                          </router-link>
                      </div>
                  </div>
              </div>
          </v-menu>
      </div>
    </div>

    <div class="division">

      <div class="sub_tit_box clear">
        <h3 class="fl">{{ categoryName }}</h3> 
      </div>

      <ul class="list-card_square col-4" v-if="boardList.length != 0">
        <li v-for="(list, index) in boardList" :key="'paper_' + index" v-show="index < 4">
          <div class="btn_top hover fr">
           <!--  <button
              type="button"
              class="ico-switch_favorites small active"
              @click="toggleBoardDibs($event, list.articleId)"
            >즐겨찾기 </button> -->
          </div>
          <div class="list-top">
            <div class="list-top">
              <div class="list-team">{{ list.userName }} </div>
            </div>
          </div>
          <div
            class="list-tit-s ell-multiline3"
            @click="moveBoard(list.linkUrl)"
            style="cursor: pointer;"
          >{{ list.subject }}</div>
          <div class="list-btm clear">
            <!--div class="list-see fl">{{ list.refCnt }}</div-->
            <!-- <button class="ico-switch-txt_like large" :class="list.paperLikeYN != null ? 'active': ''"
                    @click.stop="setPaperLike(list)">35</button> -->
            <div class="list-date fr">
              {{ $moment(list.writeDate).format("YYYY.MM.DD") }}
              <!-- <br />
              <momentAgo prefix="최종 수정" suffix="전" :date="list.writeDate" lang="kr"></momentAgo> -->
            </div>
          </div>
        </li>
      </ul>
      <ul class="list-card_square col-4" v-if="boardList.length == 0">
        <li>
          <div class="list-top">
            <div class="list-top">
              <div class="list-team"></div>
            </div>
          </div>
          <div class="list-tit-s ell-multiline3">{{ $i18nUtil.trans("message.SharingCircleContents.001","데이터가 존재하지 않습니다.") }}</div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: ["categoryMid", "categoryName", "tabKbn"],
  data() {
    return {
      /* 보드 리스트 */
      boardList: [],
 
    };
  },
  computed:{
    ...mapState("shareInfo", ["shareInfoManageYn"]),
  },
  mounted() {
    /* 카테고리 별 보드 목록 */
    //this.getCircleArticleList();
  },
  methods: {
    ...mapMutations("shareInfo", ["setShareInfoDibsList"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 선택된 보드 화면으로 이동 */
    moveBoard(linkUrl) {
      let cw = screen.availWidth;   //화면 너비
      let ch = screen.availHeight;  //화면 높이
      let sw = 838;                 //띄울 창의 너비
      let sh = 630;                 //띄울 창의 높이
      let ml = (cw - sw) / 2;       //가운데 띄우기위한 창의 x위치
      let mt = (ch - sh) / 2;       //가운데 띄우기위한 창의 y위치
      var poppwdwin = window.open(linkUrl, 'circlebbs',
        'width=' + sw + ',height=' + sh + ',top=' + mt + ',left=' + ml + ',scrollbars=yes,status=no,toolbar=no,resizable=0,location=no,menu=no');
      poppwdwin.focus();
    },

    /* 카테고리 별 보드 목록 */
    getBoardList() { 
      let obj = this;
      let reqData = {
        url: "/api/copaper/cicle/getCircleArticleList",
        method: "post",
        params: {
          boardId: this.categoryMid,
          pageNo: 1,
          searchColumn: 'SUBJECT',
          keyword: '',
          noticeIncludeYn: 'N'
        },
      };
      //프로그레스바 시작 
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => { 
          //프로그레스바 종료
          this.hideLoadingbar();
          obj.boardList = res.result.circleBoardList;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 선택된 보드 찜 등록 및 해제(1: 찜 / 2: 해제) */
    toggleBoardDibs(event, paperId) {
      event.target.classList.toggle("active");
      let obj = this;
      let reqData = {
        url: "/api/copaper/dibs/saveDibs",
        method: "post",
        params: { paperId: paperId, dibsYn: "1" },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          // console.log(res);
          this.setShareInfoDibsList(res.result.dibsList);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setPaperLike(list){
      event.target.classList.toggle("active");
      let obj = this;
      let reqData = {
        url: "/api/copaper/infoshare/setPaperLike",
        method: "post",
        params: {
          paperId: list.paperId, 
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) { 
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else { 
            obj.boardList.forEach(function(item){
              if(item.paperId == list.paperId){
                item.paperLikeCount = res.result.paperLikeCount;
              }
            }) 
          }
        })
        .catch(function (err) {
          console.log(err);
        }); 
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/base/SharingCircleContents.vue